export const WATCHLIST_DRAFT_GUIDANCE_EVENT = 'alphamizer:watchlist-draft-guidance';

const REVIEW_CODES = new Set([
    'watchlist_pending_change_exists', 'watchlist_update_in_progress',
    'watchlist_draft_invalid', 'watchlist_draft_base_changed',
    'watchlist_draft_edit_conflict', 'watchlist_draft_changed',
]);

export function showWatchlistDraftGuidance(result, sessionScopeToken) {
    const code = result?.code || result?.detail?.code;
    if (!sessionScopeToken || (!result?.combined_draft && !REVIEW_CODES.has(code))) return false;
    window.dispatchEvent(new CustomEvent(WATCHLIST_DRAFT_GUIDANCE_EVENT, {
        detail: {
            sessionScopeToken,
            revisionId: result?.watchlist_revision_id || result?.pending_revision_id || result?.detail?.pending_revision_id,
            message: result?.message || result?.detail?.message || 'Review your pending change in Watchlist History.',
        },
    }));
    return true;
}
